// extracted by mini-css-extract-plugin
export default {"container":"Banners_container__PLpXB","box":"Banners_box__dLgSb","text":"Banners_text__8NMoL"};